import PropTypes from 'prop-types';
import React from 'react';

import * as S from './Tag.styles';

export const TagAppearance = {
  SMALL: 'small',
  BIG: 'big',
};

export const Tag = ({ appearance, isSelected, children, onClick, link }) => {
  if (!children) {
    return null;
  }

  const hasLink = !!link;

  if (hasLink) {
    return (
      <S.StyledLink appearance={appearance} href={link}>
        {children}
      </S.StyledLink>
    );
  }

  return (
    <S.StyledTag
      appearance={appearance}
      isSelected={isSelected}
      onClick={onClick}
    >
      {children}
    </S.StyledTag>
  );
};

Tag.propTypes = {
  /**
   * Change the size of the tag.
   * Has Effect only if appearance === small.
   */
  appearance: PropTypes.oneOf(Object.values(TagAppearance)),
  /**
   * The displayed content of the tag.
   */
  children: PropTypes.node.isRequired,
  /**
   * Change the appearance of the tag when it is selected.
   */
  isSelected: PropTypes.bool,
  /**
   * Url that make button behaves like a link.
   */
  link: PropTypes.string,
  /**
   * Function called every time the event is triggered
   */
  onClick: PropTypes.func,
};

Tag.defaultProps = {
  appearance: TagAppearance.SMALL,
  isSelected: false,
};
